import React, { FC, useState, useContext, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Customers, EntityType } from '../../../entity/entity.types';
import { fetchLawFirmCustomers } from '../lawFirm.api';
import { EnterprisesRepresentedByLawFirm } from './EnterprisesRepresentedByLawFirm';
import {
  CustomersTypologies,
  CompanySizeTypologies,
} from '../../../entity/charts/typologies';
import { LawFirmContext } from '../LawFirmContext';
import { PageNavContext } from '../../../components/page-nav/PageNavContext';
import { EntityOutlineTitle } from '../../../entity/components/EntityOutlineTitle';
import { useUser } from '../../../user/useUser';

export const LawFirmClients: FC = () => {
  const id = 'law-firm-clients';
  const [customers, setCustomers] = useState<Customers>({
    typologies: {},
    enterprisesSizes: {},
    enterprisesSectors: {},
    sizes: {
      typologiesTotalSubset: 0,
      enterprisesSizesTotalSubset: 0,
      enterprisesSectorsTotalSubset: 0,
    },
  });
  const [shouldDisplayTitle, setShouldDisplayTitle] = useState(false);

  const {
    lawFirmInfos: { lawOfficeIdGroup, name },
    experience: { decisionCount },
  } = useContext(LawFirmContext);
  const { loggedIn } = useUser();
  const { createNav } = useContext(PageNavContext);

  const displaySection = () => {
    if (!shouldDisplayTitle) {
      setShouldDisplayTitle(true);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const customersFetched = await fetchLawFirmCustomers(lawOfficeIdGroup);
      setCustomers(customersFetched);
      const hasCustomers =
        customersFetched.sizes &&
        (customersFetched.sizes.typologiesTotalSubset > 0 ||
          customersFetched.sizes.enterprisesSizesTotalSubset > 0 ||
          customersFetched.sizes.enterprisesSectorsTotalSubset > 0);
      if (hasCustomers) {
        displaySection();
      }
    };

    fetchData();
  }, [lawOfficeIdGroup]);

  useEffect(() => {
    if (shouldDisplayTitle) {
      createNav(id);
    }
  }, [shouldDisplayTitle]);

  const entityInfos: {
    decisionCount: number;
    entityType: EntityType;
    entityId: string;
    entityName: string;
  } = {
    entityId: lawOfficeIdGroup,
    entityName: name,
    entityType: 'lawFirm',
    decisionCount,
  };
  // CompanySectorTypologies, waiting for data corrections to reactivate
  return (
    <>
      {shouldDisplayTitle && (
        <EntityOutlineTitle id={id}>
          <FormattedMessage id="law-firm/page/LawFirmClients.tsx/1" /> {name}
        </EntityOutlineTitle>
      )}
      {customers.sizes && customers.sizes.typologiesTotalSubset > 0 && (
        <CustomersTypologies customers={customers} {...entityInfos} />
      )}
      {loggedIn && (
        <EnterprisesRepresentedByLawFirm
          lawOfficeIdGroup={lawOfficeIdGroup}
          name={name}
          displaySection={displaySection}
          decisionCount={decisionCount}
        />
      )}
      {customers.sizes && customers.sizes.enterprisesSizesTotalSubset > 0 && (
        <CompanySizeTypologies customers={customers} {...entityInfos} />
      )}
      {/* {customers.sizes.enterprisesSectorsTotalSubset > 0 && (
          <CompanySectorTypologies customers={customers} {...entityInfos} />
        )} */}
    </>
  );
};
